export interface DevChartProps {
  data: number[]
  totalPoints: number
  color: string
  unit: string
  formatValue?: (n: number) => string
  fixedMax?: number
}
